module.exports = __webpack_public_path__ + "static/img/open_vip.397e5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/open_vip.png
// module id = SacS
// module chunks = 1